import { CheckCircle2, XCircle, AlertTriangle, Info, X } from "lucide-react";
import { cn } from "@repo/exit-calc-web-utils";

interface ToastProps {
  closeToast?: () => void;
  title?: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
}

const toastConfig = {
  success: {
    icon: CheckCircle2,
    containerClass: "border-success bg-success-muted",
    iconClass: "text-success",
    titleClass: "text-success-foreground",
  },
  error: {
    icon: XCircle,
    containerClass: "border-destructive bg-destructive/10",
    iconClass: "text-destructive",
    titleClass: "text-destructive",
  },
  warning: {
    icon: AlertTriangle,
    containerClass: "border-warning bg-warning-muted",
    iconClass: "text-warning",
    titleClass: "text-warning-foreground",
  },
  info: {
    icon: Info,
    containerClass: "border-info bg-info-muted",
    iconClass: "text-info",
    titleClass: "text-info-foreground",
  },
};

export function Toast({ closeToast, title, message, type }: ToastProps) {
  const config = toastConfig[type];
  const Icon = config.icon;

  return (
    <div
      className={cn(
        "relative flex w-full items-start gap-3 rounded-lg border p-4 shadow-lg",
        config.containerClass,
      )}
    >
      <Icon className={cn("mt-0.5 size-5 shrink-0", config.iconClass)} />

      <div className="flex min-w-0 flex-1 flex-col gap-1">
        {title && (
          <p className={cn("text-sm font-semibold", config.titleClass)}>
            {title}
          </p>
        )}
        <p className="text-sm text-foreground/80">{message}</p>
      </div>

      <button
        onClick={() => closeToast?.()}
        className={cn(
          "shrink-0 rounded-md p-1 opacity-60 transition-opacity hover:opacity-100",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        )}
      >
        <X className="size-4" />
        <span className="sr-only">닫기</span>
      </button>
    </div>
  );
}

